module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAMAAAD+iNU2AAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMAoO8gYMBAv1DfcDDPsJCPgBB/OC+w4gAAAGdJREFUCNdtj9EOgCAIRQG1UtOy+///moqbtnUegMPG7qCO2cXS5BEAbIaVEy4EhkT1C3e/8VJ6B+t+0/2BgxRJrVpsw0/39f3X03QxLY1pEMUbglPRKEtYqR54ZfyQ6xhpOfSSdXoBBLMEGdsMk04AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workOrderReview/Vector.png
// module id = q6dz
// module chunks = 0